import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import RoomBookingSearchInput from './RoomBookingSearchInput';
import RoomBookingSearchResults from './RoomBookingSearchResults';
import ModalTrigger from './ModalTrigger';
import AlertBox from './AlertBox';
import Popover from './Popover';

export default class RoomBookingSearch extends Component {
  static propTypes = {
    locationData: PropTypes.object,
    locationId: PropTypes.string,
    date: PropTypes.string,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    existingBookingsUrl: PropTypes.string,
    calendarUrl: PropTypes.string,
    sourceUrl: PropTypes.string,
    availableRooms: PropTypes.array,
    unavailableRooms: PropTypes.array,
    alternativeTimes: PropTypes.array,
  }

  constructor(props) {
    super(props);
    const timezone = this.props.locationData[this.props.locationId].timezone;

    this.state = {
      availableRooms: this.props.availableRooms,
      unavailableRooms: this.props.unavailableRooms,
      alternativeTimes: this.props.alternativeTimes,
      date: this.props.date,
      locationId: this.props.locationId,
      startTime: this.props.startTime,
      endTime: this.props.endTime,
      validInput: true,
      message: '',
      bookingError: false,
      timezone,
    };
  }

  inputChangeCallback = (locationId, date, startTime, endTime, timezone) => {
    this.setState({
      locationId,
      date,
      startTime,
      endTime,
      timezone,
      validInput: true,
    }, this.search);
  }

  invalidInputCallback = () => {
    this.setState({ validInput: false });
  }

  handleAlertClick = () => {
    this.setState({ message: '' });
  }

  search() {
    $.ajax({
      url: this.props.sourceUrl,
      type: 'get',
      data: {
        search: {
          location: this.state.locationId,
          start_time: this.state.startTime,
          end_time: this.state.endTime,
        },
      },
      dataType: 'json',
      success: function (result) {
        this.setState({
          availableRooms: result.availableRooms,
          unavailableRooms: result.unavailableRooms,
          alternativeTimes: result.alternativeTimes,
        });
      }.bind(this),
    });
  }

  /**
  * bookingAttemptEvent() responds to the global event triggered by booking#create.js
  * by displaying either the success message or an error, depending on the event
  */
  bookingAttemptEvent = (e, message, bookingError) => {
    this.search();
    this.setState({ message, bookingError });
  }

  // alternativeTimeSearch() allows the RoomBookingSearchResults component to alter the current date and time settings
  alternativeTimeSearch = (startTime, endTime) => {
    this.setState({ startTime, endTime }, this.search);
  }

  /**
  * Set event listener for new booking creation. Documentation here:
  * https://facebook.github.io/react/tips/communicate-between-components.html
  */
  componentDidMount() {
    $(ReactDOM.findDOMNode(this)).on('room-booking:booking-attempt', this.bookingAttemptEvent);
  }

  render() {
    return (
      <div className={`u-main u-relative ${this.state.message ? 'u-mt-0 u-pt-20' : ''}`}>
        <div className="u-absolute u-top-0 u-left-0 u-right-0 h-12">
          <AlertBox
            message={this.state.message}
            type={this.state.bookingError ? 'alert' : 'notice'}
            onClick={this.handleAlertClick}
            dismissable
          />
        </div>
        <div className="u-sidebar">
          <h3 className="u-panel-heading u-mb-4">
            View
          </h3>
          <ul className="List List--multiple List--medium u-panel">
            <li className="u-font-semibold">
              <a className="u-block" href={this.props.sourceUrl}>
                Room Booking
              </a>
            </li>
            <li>
              <a className="u-block" href={this.props.calendarUrl}>
                Room Calendar
              </a>
            </li>
          </ul>
          { this.state.unavailableRooms.length > 0 &&
            <div>
              <h3 className="u-panel-heading u-my-4">
                Unavailable Rooms
              </h3>
              <div className="u-panel u-p-5 u-mt-4 u-clearfix">
                { this.state.unavailableRooms.map((room) => {
                  const features = [];
                  room.attributes_list.forEach((feature, i) => {
                    features.push(<li className="u-m-0 u-p-0" key={`${room.name}-feature-${i + 1}`}>{feature}</li>);
                  });
                  return (
                    <div key={`${room.name}`}>
                      <Popover text={room.name} hover>
                        <ul className="u-m-0 u-p-0">{features}</ul>
                      </Popover>
                    </div>
                  );
                })
              }
              </div>
            </div>
          }
        </div>
        <div className="u-content">
          <div className="RoomSearch">
            <div className="RoomSearch-input">
              <h3 className="u-panel-heading u-mb-4">
                Search for rooms
              </h3>
              <div className="u-panel u-p-5 u-mb-4 u-clearfix">
                <h3 className="u-text-xl u-font-semibold u-inline-block">Book a Room</h3>
                <ModalTrigger
                  triggerIcon="Icon Icon-event-available u-mr-2"
                  triggerLabel="My Bookings"
                  triggerClassName="Button Button--small u-float-right"
                  async
                  asyncUrl={this.props.existingBookingsUrl} />

                <RoomBookingSearchInput
                  locationData={this.props.locationData}
                  locationId={this.state.locationId}
                  date={this.state.date}
                  startTime={this.state.startTime}
                  endTime={this.state.endTime}
                  inputChangeCallback={this.inputChangeCallback}
                  invalidInputCallback={this.invalidInputCallback}
                  timezone={this.state.timezone}
                />
              </div>
              { (this.state.availableRooms.length > 0 || this.state.alternativeTimes.length > 0) &&
                <div>
                  <h3 className="u-panel-heading u-mb-4">
                    Available Rooms
                  </h3>
                  <div className="u-panel u-p-5 u-mt-4 u-clearfix">
                    <RoomBookingSearchResults
                      availableRooms={this.state.availableRooms}
                      alternativeTimes={this.state.alternativeTimes}
                      show={this.state.validInput}
                      timezone={this.state.timezone}
                      searchCallback={this.alternativeTimeSearch}
                    />
                  </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
